
import CloudConnection from "../../../assets/duotone/CloudConnection.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CloudConnectionIcon({ className, dataTestid = "CloudConnectionIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CloudConnection data-testid={dataTestid} className={classes} {...rest} />
  );
}
